export default __webpack_public_path__ + "24e1a4c.png";